export default __webpack_public_path__ + "static/pattern-blue-acb3f447ea417bbae8ce9b9c6479a376.svg";